module.exports = __webpack_public_path__ + "img/WhaleLive.4b31d0e4.jpg";